import React from 'react';
import { useSelector } from 'react-redux';
import Icon from '../../../ui/icons/Icon';
import iconsList from '../../../ui/icons/iconsList';
import classes from './PromotionNav.module.css';

const PromotionNav = ({ currentIndex, totalCount, onPrev, onNext }) => {

    const { texts } = useSelector(state => state.translate);
    const canGoPrev = currentIndex > 0;
    const canGoNext = currentIndex < totalCount - 1;

    return (
        <div className={classes.Nav} dir="ltr">
            <button
                type="button"
                className={classes.NavButton}
                onClick={onPrev}
                disabled={!canGoPrev}
                aria-label={texts.previous}
            >
                <Icon
                    name={iconsList.tabScrollChevron}
                    width="8px"
                    height="15px"
                    className={classes.Chevron}
                />
            </button>
            <span className={classes.Counter}>{currentIndex + 1}/{totalCount}</span>
            <button
                type="button"
                className={classes.NavButton}
                onClick={onNext}
                disabled={!canGoNext}
                aria-label={texts.next}
            >
                <Icon
                    name={iconsList.tabScrollChevron}
                    width="8px"
                    height="15px"
                    className={`${classes.Chevron} ${classes.ChevronNext}`}
                />
            </button>
        </div>
    );
};

export default PromotionNav;
